export default "__VITE_ASSET__5fb7168a__"